///
/// EarthBrowser
///
/// Migration v33 to v34: Add borders vector layer visibility
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v33 to v34
 *
 * Changes:
 * - Appends "borders" (political boundary vector tiles) to
 *   earthbrowser.visibleDatasets so the new layer defaults to on
 *   for existing users, matching the default for new users.
 */
interface StateV33 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

export function migrateV33toV34(state: unknown): unknown {
	const s = state as StateV33 | null | undefined
	if (!s?.earthbrowser || !Array.isArray(s.earthbrowser.visibleDatasets)) return state

	const visibleDatasets = [...s.earthbrowser.visibleDatasets]
	if (!visibleDatasets.includes("borders")) {
		visibleDatasets.push("borders")
	}

	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			visibleDatasets,
		},
	}
}
